import React, { createContext, useContext, useEffect, useReducer } from "react";
import useSWR from "swr";
import fetcher from "../utils/fetcher";
import { useAuth } from "react-oidc-context";
import { getRoles, prepareRole } from "./session";

const GlobalStateContext = createContext();

const initialState = {
  ownerGroups: null,
  roles: null,
};

const reducer = (state, action) => {
  switch (action.type) {
  case "OWNERGROUP":
    return { ...state, ownerGroups: action.payload };
  case "ROLES":
    return { ...state, roles: action.payload };
  default:
    return state;
  }
};

const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const auth = useAuth();
  const {user} = auth;

  // Set reference data in global state when it changes
  useEffect(() => {
    if (user) {
      // const roleAndOwnerGroup = JSON.parse(userAttr.signInUserSession.idToken.payload.ownerGroup);
      // const roles = roleAndOwnerGroup.forEach(item => {
      //   if (item.entity === 'USERROLE') {
      //     item;
      //   }
      // });
      // const ownerGroups = roleAndOwnerGroup.forEach(item => {
      //   if (item.entity === 'USEROWNERGROUP') {
      //     item;
      //   }
      // });
      // const ownerGroup = [{id: user.profile.sub, name: user.profile.given_name}];
      // let roles = getRoles(user); //JSON.parse(userAttr.signInUserSession.idToken.payload.roles);
      // let ownerGroups = ownerGroup; // JSON.parse(user.profile.ownerGroups); // JSON.parse(userAttr.signInUserSession.idToken.payload.ownerGroups);

      let roles = prepareRole(user.profile.roles  || []);
      let ownerGroups = prepareRole(user.profile.roles  || []);

      dispatch({ type: "OWNERGROUP", payload: ownerGroups });
      dispatch({ type: "ROLES", payload: roles });
    }
  }, [user]);

  return (
    <GlobalStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};

export { GlobalStateProvider, useGlobalState };
